import styled from '@emotion/styled'

export const Flex = styled.div`
  display: flex;
  flex-direction: ${(props) => props.flexDirection};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
  width: ${(props) => props.width};
`
export const Content = styled(Flex)`
  margin: 0 0 0 -1rem;
`
